import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.array.sort";
import { getCookieValue, setCookieValue, windowExists } from './helpers';

var getContextHub = function getContextHub() {
  if (windowExists) {
    var contextHub = window.sessionStorage.getItem('ContextHubPersistence');
    return contextHub ? JSON.parse(contextHub) : null;
  } else {
    return null;
  }
};

var getContextHubStore = function getContextHubStore() {
  var contextHub = getContextHub();

  if (!contextHub || !contextHub.store) {
    return;
  }

  var _contextHub$store = contextHub.store,
      origin = _contextHub$store.origin,
      originmyacc = _contextHub$store.originmyacc;

  if (!origin || !originmyacc) {
    return;
  }

  return {
    origin: origin,
    originmyacc: originmyacc
  };
};

var deriveContractAccountId = function deriveContractAccountId(premiseId) {
  var contextHubStore = getContextHubStore();

  if (!contextHubStore) {
    return;
  }

  var contracts = contextHubStore.originmyacc['originStore.contracts'];

  if (!contracts) {
    return;
  }

  var sortedContracts = _Object$keys(contracts).filter(function (key) {
    return contracts[key].active && contracts[key].premiseId === premiseId;
  }).sort(function (a, b) {
    return _parseInt(contracts[a].divisionId, 10) - _parseInt(contracts[b].divisionId, 10);
  });

  if (!sortedContracts || sortedContracts.length === 0) {
    return;
  }

  var contractAccountId = contracts[sortedContracts[0]].businessAgreementId;

  if (!contractAccountId) {
    return;
  }

  return contractAccountId;
};

var AEM_PREMISE_ID_COOKIE_NAME = 'pmid';

var setPremiseId = function setPremiseId(premiseId) {
  if (typeof document === 'undefined') {
    return;
  }

  setCookieValue(AEM_PREMISE_ID_COOKIE_NAME, premiseId, {
    path: '/',
    secure: true
  });
};

var getPremiseIdFromCookie = function getPremiseIdFromCookie() {
  return getCookieValue(AEM_PREMISE_ID_COOKIE_NAME);
};

var getPremiseIdFromContextHub = function getPremiseIdFromContextHub() {
  var contextHubStore = getContextHubStore();
  return contextHubStore ? contextHubStore.origin.selectedPremiseId : undefined;
};

export var AemContextHub = {
  deriveContractAccountId: deriveContractAccountId,
  getPremiseIdFromContextHub: getPremiseIdFromContextHub,
  getPremiseIdFromCookie: getPremiseIdFromCookie,
  setPremiseId: setPremiseId
};